<div class="flex-row padding-30">
  <div class="flex-1"></div>

  <div class="flex-3">
    <form [formGroup]="employeeForm" (ngSubmit)="onSubmit()" class="flex-column form-content justify-center" style="align-items: center;">
      <h1 class="margin-bottom-25 center-text">{{formAction}} an Employee</h1>
      <div class="flex-column form-content justify-center w-50">
        <mat-form-field>
          <mat-label>First Name *</mat-label>
          <input matInput type="text" formControlName="firstName" [ngClass]="{ 'is-invalid': submitted && formControls.firstName.errors }" />
          @if (submitted && formControls.firstName.errors) {
              @if (formControls.firstName.errors.required) {
                <mat-error>First name is required</mat-error>
              }
          }
        </mat-form-field>

        <mat-form-field>
          <mat-label>Last Name *</mat-label>
          <input matInput type="text" formControlName="lastName" [ngClass]="{ 'is-invalid': submitted && formControls.lastName.errors }" />
          @if (submitted && formControls.lastName.errors) {
            <div class="invalid-feedback">
              @if (formControls.lastName.errors.required) {
                <div>Last name is required</div>
              }
            </div>
          }
        </mat-form-field>

        <mat-form-field>
          <mat-label>Email *</mat-label>
          <input matInput type="email" formControlName="emailAddress" [ngClass]="{ 'is-invalid': submitted && formControls.emailAddress.errors }" />
          @if (formControls.emailAddress.hasError('email') && !formControls.emailAddress.hasError('required')) {
            <mat-error>
              Please enter a valid email address
            </mat-error>
          }
          @if (formControls.emailAddress.hasError('required')) {
            <mat-error>
              Email is required
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field>
          <mat-label>Employee Role</mat-label>
          <mat-select [(ngModel)]="selectedEmployeeRole" [ngModelOptions]="{standalone: true}">
            @for (employeeRole of employeeRoles | keyvalue; track employeeRole) {
              <mat-option [value]="employeeRole.key">
                {{employeeRole.value}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Password</mat-label>
          <input matInput type="password" formControlName="password" />
        </mat-form-field>

        <div class="flex-row">
          <div class="flex-2"></div>
          <button [disabled]="loading || employeeForm.invalid" mat-raised-button color="primary" class="w-100">
            Save
          </button>
          <div class="flex-2"></div>
        </div>
      </div>
    </form>
  </div>

  <div class="flex-1">
    <button mat-icon-button (click)="goBack()" class="float-right" aria-label="Return to employees screen">
      <mat-icon>arrow_back</mat-icon>
    </button>
  </div>
</div>

